import { render, staticRenderFns } from "./AlMix.vue?vue&type=template&id=50477c6b&scoped=true"
import script from "./AlMix.vue?vue&type=script&lang=js"
export * from "./AlMix.vue?vue&type=script&lang=js"
import style0 from "./AlMix.vue?vue&type=style&index=0&id=50477c6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50477c6b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VLazy,VRow})
